import {signInWithEmailAndPassword as firebaseSignInWithEmailAndPassword} from 'firebase/auth';

import {authInstance} from './firebase';

/**
 * Wait for auth to initialize, then return the current user
 */
export async function getCurrentUser() {
	await authInstance.authStateReady();

	return authInstance.currentUser;
}

export async function getIdToken() {
	return (await getCurrentUser())?.getIdToken();
}

export async function signInWithEmailAndPassword(
	email: string,
	password: string,
) {
	return firebaseSignInWithEmailAndPassword(authInstance, email, password);
}
